import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { checkReverseFNC, reverseFNC } from 'lib/api/fnc';
import CustomButton from 'lib/designSystem/Button';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

interface ReverseFNCDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fncForReverseId: number;
  bigSetUp: () => void;
}

const ReverseFNCDialog = (props: ReverseFNCDialogProps) => {
  const { open, setOpen, fncForReverseId, bigSetUp } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [canReverse, setCanReverse] = useState(false);
  const [reason, setReason] = useState('');

  const setUp = async () => {
    setLoading(true);
    try {
      const response = await checkReverseFNC(dispatch, fncForReverseId);
      setCanReverse(response.canReverse);
      setReason(response.reason);
    } catch (error) {
      showAlert(
        dispatch,
        'error',
        'Error al evaluar si se puede reversar el FNC',
      );
    }
    setLoading(false);
  };

  const handleReverse = async () => {
    setLoading(true);
    try {
      await reverseFNC(dispatch, fncForReverseId);
      showAlert(dispatch, 'success', 'FNC reversado correctamente');
      void bigSetUp();
      setOpen(false);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al reversar el FNC');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (fncForReverseId) {
      void setUp();
    }
  }, [fncForReverseId]);

  return (
    <Dialog open={open}>
      <DialogTitle>Reversar FNC ID: {fncForReverseId}</DialogTitle>
      <DialogContent>
        <Typography>¿Estás seguro de querer reversar este FNC?</Typography>
        <Typography>
          - El pago de origen de este FNC pasará a estado <b>Pendiente</b>.
        </Typography>
        <Typography>- El FNC será eliminado.</Typography>
        {reason && (
          <Typography color="error" sx={{ mt: 1 }}>
            {reason}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => setOpen(false)}
          disabled={loading}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleReverse}
          disabled={loading || !canReverse}
          color="error"
        >
          Reversar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ReverseFNCDialog;
